import React from 'react'

import { type GroupAndAll } from '~/utils'

import { useTabulatedGroups } from './useTabulatedGroups'

export const useTabulatedGroupsAndAll = () => {
  const tabulatedGroups = useTabulatedGroups()

  return React.useMemo<GroupAndAll[]>(
    () => ['all', ...tabulatedGroups],
    [tabulatedGroups],
  )
}
